import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Select, Button, Grid } from 'semantic-ui-react';

import { Filter, Main } from 'Containers/';
import { YesNoDialog } from 'Components/';
import { DirtyWrapper } from 'Components/';
import { ServedItemsTable } from './components/ServedItemsTable';
import { getInitialData, deleteItem } from './state/serveditemsetup/actions';
import { ItemFilterOptions } from './helpers/constants';

import { AssignSitesToServedItemModal } from '../serveditemaccesssetup/AssignSitesToServedItemModal';

class ServedItemSetupContainer extends Component {
  state = {
    itemFilters: ItemFilterOptions.map(c => c.value),
    showDeleteModal: false,
    showAssignSitesModal: false,
    deleteId: null,
  };

  componentWillMount() {
    this.props.getInitialData();
  }

  cogOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: row => {
        this.props.history.push(`/serveditemsetup/${row.Id}`);
      },
    },
    {
      icon: 'trash',
      text: 'Delete',
      handler: row => {
        this.setState({ showDeleteModal: true, deleteId: row.Id });
      },
      disabledWhen: row => row.StatusCurrent === '9' || this.props.isReadOnly,
    },
    {
      icon: 'marker',
      text: 'Assign Sites',
      handler: row => {
        this.setState({
          showAssignSitesModal: {
            servedItemId: row.Id,
            name: row.Description,
          },
        });
      },
    },
  ];

  getFilteredServedItems = () => {
    return this.props.servedItems.filter(i =>
      this.state.itemFilters.some(f => i.MealId === f)
    );
  };

  render() {
    const { history, deleteItem, loading } = this.props;

    return (
      <Fragment>
        {/* {this.props.loading ? <LoadingPage /> : undefined} */}
        <Filter title={'Served Item Setup'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8}>
                <Select
                  multiple
                  label={'Filter By'}
                  onChange={(e, change) =>
                    this.setState({ itemFilters: change.value })
                  }
                  value={this.state.itemFilters}
                  options={ItemFilterOptions}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Button
                  content="Item Color Setup"
                  onClick={() => {
                    history.push(`/serveditemsetup/color/setup`);
                  }}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Button
                  content="Create New"
                  // disabled={}
                  onClick={() => {
                    history.push(`/serveditemsetup/0`);
                  }}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main>
          <ServedItemsTable
            data={this.getFilteredServedItems()}
            cogOptions={this.cogOptions}
            loading={loading}
          />
        </Main>
        <YesNoDialog
          title={'Delete item?'}
          question={`Are you sure you want to delete item ${this.state.deleteId}?`}
          showDialog={this.state.showDeleteModal}
          yesCallback={() => {
            deleteItem(this.state.deleteId);
            this.setState({ showDeleteModal: false, deleteId: null });
          }}
          noCallback={() => {
            this.setState({ showDeleteModal: false, deleteId: null });
          }}
        />
        <DirtyWrapper
          closeModalYesCallback={() =>
            this.setState({ showAssignSitesModal: false })
          }
        >
          {showDirtyConfirm =>
            this.state.showAssignSitesModal && (
              <AssignSitesToServedItemModal
                onClose={showDirtyConfirm}
                {...this.state.showAssignSitesModal}
              />
            )
          }
        </DirtyWrapper>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.ServedItemSetupState.ServedItemSetup.fetching,
    servedItems: state.ServedItemSetupState.ServedItemSetup.servedItems,
  };
};

export const ServedItemSetup = withRouter(
  connect(mapStateToProps, { getInitialData, deleteItem })(
    ServedItemSetupContainer
  )
);



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/ServedItemSetup.js